import { render, staticRenderFns } from "./ProjectSettingsView.vue?vue&type=template&id=37f9914b&"
import script from "./ProjectSettingsView.vue?vue&type=script&lang=js&"
export * from "./ProjectSettingsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports